var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    { staticClass: "expansion-docs" },
    _vm._l(_vm.sections, function (section, index) {
      return _c(
        "v-expansion-panel",
        [
          _c(
            "v-expansion-panel-header",
            { attrs: { "expand-icon": "mdi-plus" } },
            [
              _c("h4", { staticClass: "expansion-docs__title" }, [
                _vm._v(_vm._s(section.name)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("v-expansion-panel-content", [
            _c(
              "ol",
              { staticClass: "expansion-docs__list" },
              _vm._l(section.links, function (link, index) {
                return _c(
                  "li",
                  { key: index, staticClass: "expansion-docs__item" },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "expansion-docs__link",
                        attrs: { href: link.href, target: "_blank" },
                      },
                      [
                        _c("img", {
                          attrs: { src: "/upload/pdf.svg", alt: "pdf" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "expansion-docs__info" }, [
                          _c("span", [_vm._v(_vm._s(link.name))]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "expansion-docs__info--details" },
                            [
                              _c("span", [_vm._v(_vm._s(link.date))]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(link.size))]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M4 15.2044L4 18.8925C4 19.4514 4.21071 19.9875 4.58579 20.3827C4.96086 20.778 5.46957 21 6 21H18C18.5304 21 19.0391 20.778 19.4142 20.3827C19.7893 19.9875 20 19.4514 20 18.8925V15.2044M12.0011 3V14.9425M12.0011 14.9425L16.5725 10.3793M12.0011 14.9425L7.42969 10.3793",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }